import { Compass } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/ui/empty-state';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="rounded-xl border border-border bg-surface shadow-(--c-shadow-sm)">
      <EmptyState
        icon={<Compass size={22} />}
        title="Page not found"
        description="That page doesn't exist or has moved."
        action={
          <Button size="md" className="min-h-[44px]" onClick={() => navigate('/')}>
            Back to overview
          </Button>
        }
      />
    </div>
  );
}
